import React from "react";
import { IoIosArrowForward } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const Card = ({ item }) => {
const Navigate = useNavigate();

  console.log("dta453", item);
  return (
    <div className="w-full p-8 bg-white shadow-lg shadow-Background2 transform transition duration-300 hover:scale-105 rounded-3xl">
      <div className="flex">
        <div className="w-5/12">
          <img src={item?.image?.location} className="w-full" alt="" />
        </div>
        <div className="flex flex-col w-7/12 justify-between">
          <span className="text-textColor font-semibold text-xl sm:text-3xl md:text-xl pt-3">
            {item?.name}
          </span>
          <div className="flex justify-end">
            <div className="bg-textColor hover:bg-Background6  px-4 py-1 rounded-3xl text-lg font-semibold text-white flex gap-3 items-center mt-3" onClick={()=>{
              Navigate(`/product/${item?._id}/${item?.type}`)
            }}>
              <span >Explore </span>
              <span>
                <IoIosArrowForward />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
